export class ReviewListVM {
    id: number;
    name: string;
    title: string;
    comments: string;
    image: string;
    imageLoader: boolean = true;
}

export class AllReviewList {
    ProductSort: Array<ReviewListVM> = [];
    TotalPages: number;
}

export class ReviewListing {
    PageNumber: number = 1;
    PageSize: number = 3;
}

export class MobileReviewListingModel {
    PageNumber: number = 1;
    PageSize: number = 1;
}

export class ReviewAdd {
    name: string;
    title: string;
    comments: string;
    id: number;
}

export class ReviewGetItem {
    name: string;
    title: string;
    comments: string;
    isActiveValue: string;
}

export class ReviewUpdateItem {
    id: number;
    name: string;
    title: string;
    comments: string;
    IsActive: string;
}

export class AdminReviewListing {
    PageNumber: number = 1;
    PageSize: number = 10;
    KeyWord: string;
}

export class DeleteReviewItem {
    Id: number;
}

export class UploadFileModel {
    Id: number;
    ImageName: string;
    FileDescription: string;
    Image: any;
    FileTitle: string ;
    FileType: string ;
    name: string;
}

export class GetAssetsReviewImage {
    filePath: any;
    type: number;
    reviewImageLoader: boolean = false;
}

export class CustomerReviewModel {
    name: string;
    title: string;
    comments: string;
    id: number;
}